import api from '@/api'
import { defineSyncSchema, schemaKinds, createSyncState, createSyncRequest, mergeSyncResponse, recordWrite, syncMutations } from '@/helpers/storeSync'

const PARAMETRO_SYNC_SCHEMA = defineSyncSchema({ key: 'CLAVE', kind: 'parametro', insertAt: 'end' })

const state = {
  parametros: [],
  sync: createSyncState(schemaKinds(PARAMETRO_SYNC_SCHEMA))
}

const getters = {
  parametros: (state) => state.parametros,

  getParametro: (state) => (key) => {
    let parametro = null

    if (key) {
      parametro = state.parametros.find(x => x.CLAVE.equalsIgnoreCase(key))
    }
    return parametro ? parametro.VALOR : null
  }
}

const mutations = {
  ...syncMutations,

  MERGE_PARAMETROS(state, { rows, request }) {
    state.parametros = mergeSyncResponse(state.sync, state.parametros, rows, PARAMETRO_SYNC_SCHEMA, request)
  },

  SOCKET_updateParametro(state, data) {
    if (Array.isArray(data)) {
      data.forEach(({ CLAVE, VALOR }) => {
        const index = state.parametros.findIndex(x => x.CLAVE.equalsIgnoreCase(CLAVE))
        if (index > -1) {
          state.parametros[index].VALOR = VALOR
          recordWrite(state.sync, 'parametro', CLAVE)
        }
      })
      this.notify('Parámetros actualizados', 'Los parámetros se han actualizado correctamente', 'success')
    } else {
      const { CLAVE, VALOR } = data
      const index = state.parametros.findIndex(x => x.CLAVE.equalsIgnoreCase(CLAVE))
      if (index > -1) {
        state.parametros[index].VALOR = VALOR
        recordWrite(state.sync, 'parametro', CLAVE)
        this.notify('Parametro actualizado', 'El parámetro se ha actualizado correctamente', 'success')
      }
    }
  }
}

const actions = {
  async fetchParametros({ commit, state }) {
    try {
      commit('BEGIN_SYNC_REQUEST')
      const request = createSyncRequest(state.sync.seq)
      const response = await api.parametro.getParametros()
      commit('MERGE_PARAMETROS', { rows: response.data, request })
    } catch (err) {
      console.error(err)
      throw err
    }
  },

  async changeParametro({ commit }, data) {
    try {
      await api.parametro.setParametro(data)
    } catch (err) {
      console.error(err)
      throw err
    }
  },
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
